export const DEFAULT_PLACE = [
  {
    regionName: "hanoi",
    placeName: "Ga Hà Nội",
    description: "120 Đ. Lê Duẩn, Văn Miếu, Hoàn Kiếm, Hà Nội, Việt Nam",
    lat: 21.0243303,
    lng: 105.8410933,
    place_id: "ChIJrwU5-56rNTERCecYnwnKphs",
  },
  {
    regionName: "hanoi",
    placeName: "Bến xe Giáp Bát",
    description: "Đ. Giải Phóng, Giáp Bát, Hoàng Mai, Hà Nội, Việt Nam",
    lat: 20.9806483,
    lng: 105.8419952,
    place_id: "ChIJSVRp-o2tNTERnDeQ4cYp09o",
  },
];

export const DEFAULT_AIRPORT = {
  regionName: "hanoi",
  placeName: "Cảng hàng không Nội Bài",
  description: "Sân bay Quốc tế Nội Bài, Phú Cường, Sóc Sơn, Hà Nội",
  lat: 21.21743891600005,
  lng: 105.79886420900004,
  place_id:
    "mlCguF-7dgSoi5I1X1537JnWblErc6TbEKF1u3ZbRcqg1X0rpQVCloqxPCCjYGyXjtZ1I7tfUcNLpsl8SoXJiy5LVYb64e3bbkldEspJid_uCiFcEpAR1kumgXy-SBXfS",
};

export const EVehicleType = {
  CAR4: "CAR4",
  CAR7: "CAR7",
};

export const listVehicle = {
  [EVehicleType.CAR4]: {
    seatCount: 4,
  },
  [EVehicleType.CAR7]: {
    seatCount: 7,
  },
};

export const EStatusTrip = {
  COMING: "COMING",
  NOT_FOUND: "NOT_FOUND",
  TIMEOUT: "TIMEOUT",
  ARRIVED: "ARRIVED",
  CCANCELLED: "CCANCELLED",
  DCANCELLED: "DCANCELLED",
  ACANCELLED: "ACANCELLED",
  PCANCELLED: "PCANCELLED",
  JOURNEY: "JOURNEY",
  FINISHED: "FINISHED",
  PAID: "PAID",
  FINDING: "FINDING",
  MISSED: "MISSED",
};

export const endPointLocationDrivers = [
  EStatusTrip.COMING,
  EStatusTrip.ARRIVED,
];

export const canceledTripStatus = [
  EStatusTrip.CCANCELLED,
  EStatusTrip.DCANCELLED,
  EStatusTrip.ACANCELLED,
  EStatusTrip.PCANCELLED,
];

export const labelsStatusTrip = {
  [EStatusTrip.COMING]: "Tài xế đang đến đón quý khách",
  [EStatusTrip.JOURNEY]: "Đang di chuyển",
  [EStatusTrip.ARRIVED]: "Tài xế đã đến điểm đón",
  [EStatusTrip.NOT_FOUND]: "Không có tài xế nhận chuyến",
  [EStatusTrip.MISSED]: "Không có tài xế nhận chuyến",
  [EStatusTrip.TIMEOUT]: "Không có tài xế nhận chuyến",
  [EStatusTrip.PAID]: "Đã thanh toán",
  [EStatusTrip.FINDING]: "Tìm tài xế",
  [EStatusTrip.CCANCELLED]: "Chuyến đi đã bị hủy",
  [EStatusTrip.DCANCELLED]: "Chuyến đi đã bị hủy",
  [EStatusTrip.ACANCELLED]: "Chuyến đi đã bị hủy",
  [EStatusTrip.PCANCELLED]: "Chuyến đi đã bị hủy",
  [EStatusTrip.FINISHED]: "Chuyến đi đã hoàn thành",
};
